// extracted by mini-css-extract-plugin
export default {"buttonRootTall":"AzoButton_buttonRootTall__g9hnm","disabled":"AzoButton_disabled__1DaA5"};